<app-top-nav></app-top-nav>

<div class="content">
    <div class="wrapper">
      <p class="title" i18n="@@admin.maintenance.message">Maintenance Message</p>
      <form [formGroup]="maintenanceMessageForm" class="maintenance-message-form" (ngSubmit)="submitMaintenanceMessage()">
        <div class="d-flex flex-row mb-2">
          <label class="form-label required">Message Title</label>
        </div>
        <div class="d-flex flex-row mb-6">
        <input type="text" formControlName="messageTitle" class="form-control" placeholder="Enter message title" />
        </div>
        <div class="d-flex flex-row mb-2">
            <label class="form-label required">Message Body</label>
        </div>

        <div class="d-flex flex-row mb-8">
            <textarea formControlName="messageBody" class="form-control" placeholder="Enter message body" rows="4"></textarea>
        </div>
        <div class="d-flex flex-row mb-2">
          <label class="form-label">More Info URL</label>
        </div>
        <div class="d-flex flex-row mb-6">
          <input type="text" formControlName="urlMoreInfo" class="form-control" placeholder="Enter more info URL" />
        </div>

        <div class="d-flex flex-row mb-2 align-items-center">
          <label class="form-label me-2">Enable</label>
          <input type="checkbox" formControlName="enabled" />
        </div>

        <div class="d-flex flex-row mt-5 button-row">
          <!-- <button
            class="trigger text-uppercase me-2"
            type="submit"
           
          >
            Submit Maintenance Message
          </button> -->
          <p-button type ="submit" [disabled]="!canSubmit()">Submit</p-button>
        </div>
      </form>
      
    </div>
  </div>